import { render, staticRenderFns } from "./couponManage.vue?vue&type=template&id=581b3b52&scoped=true"
import script from "./couponManage.vue?vue&type=script&lang=js"
export * from "./couponManage.vue?vue&type=script&lang=js"
import style0 from "./couponManage.vue?vue&type=style&index=0&id=581b3b52&lang=scss"
import style1 from "./couponManage.vue?vue&type=style&index=1&id=581b3b52&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b3b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581b3b52')) {
      api.createRecord('581b3b52', component.options)
    } else {
      api.reload('581b3b52', component.options)
    }
    module.hot.accept("./couponManage.vue?vue&type=template&id=581b3b52&scoped=true", function () {
      api.rerender('581b3b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketingManage/couponManage/couponManage.vue"
export default component.exports